<template>
    <div>
        <p class="top-codes">
            <a href="/codes" class="bold-black">Codes</a>
        </p>
        <v-treeview
            role="list"
            ref="treeview"
            activatable
            :active="[activeCategory]"
            @update:open="fixAccessibilityRoles"
            :open.sync="openNodes"
            v-model="category"
            :items="navigationCategories"
            item-key="key"
            class="treeview-icon">

            <template v-slot:label="{ item, active }">
                <div @click.stop="setTreeCategory(item)" class="tree-item-label">
                    <a :href="getCategoryUrl(item)" @click.self.prevent>
                        {{ item.name }}
                    </a>
                </div>
            </template>

        </v-treeview>
    </div>
</template>

<script>
import Mobile from '../../inc/mixins/mobile';
import Categories from "../../inc/mixins/categories";
import CategoryManager from '../../inc/managers/CategoryManager';
import { getTopLevelOrderedCategories } from "../../codes/Utils/CategorySorting";

export default {
    data() {
        return {
            category: [],
            categoryList: [],
            openNodes: [],
            activeCategory: 'all-titles',
            currentCategoryPath: ''
        };
    },
    mixins: [Mobile, Categories],
    computed: {
        navigationCategories() {
            const { Category = [], Location = [] } = this.$store.getters.getSearchNavigationCategories;
            const categories = [...Category, ...Location];
            return getTopLevelOrderedCategories(categories);
        }
    },
    methods: {
        fixAccessibilityRoles() {
            this.$nextTick(() => {
                const treeview = this.$refs.treeview;
                if (!treeview) return;

                const treeEl = treeview.$el;
                treeEl.setAttribute('role', 'list');

                const parentContainers = treeEl.querySelectorAll('.v-treeview-node__children');
                parentContainers.forEach(node => {
                    node.setAttribute('role', 'list');
                });
                const nodes = treeEl.querySelectorAll('.v-treeview-node');
                nodes.forEach(node => {
                    node.setAttribute('role', 'listitem');
                });
            });
        },
        setTreeCategory(catObject) {
            let data = {
                resetPage: true,
                query: {
                    searchTerm: '',
                    category: catObject.name,
                    astmSubject: null,
                    year: !this.$store.getters.getSearchNavigationCategoryNames.includes(catObject.name) && catObject.default_year_current_adoption
                        ? 'Current Adoption'
                        : null
                }
            };
            this.defaultSearch = '';
            EventBus.fire('update-search-data', data);
        },
        getCategoryUrl(item) {
            return `/codes/${item.fullUrl}`;
        },
        scrollActiveItemIntoView(sendPageView = true) {
            this.$nextTick(() => {
                const activeNode = document.querySelector('.v-treeview-node--active');

                if (activeNode) {
                    activeNode.scrollIntoView({
                        behavior: 'smooth',
                        block: 'start',
                        inline: 'nearest'
                    });

                    if (sendPageView) {
                        EventBus.fire('send-page-view', this.currentCategoryPath);
                    }
                }
            });
        },
        updateActiveCategoryFromUrl() {
            const currentPath = window.location.pathname.replace(/^\/codes\//, ''); // remove '/codes/' prefix
            const matched = this.findPathByFullUrl(this.navigationCategories, currentPath);

            if (matched) {
                this.activeCategory = matched.item.key;
                this.category = [matched.item.key];
                this.openNodes = matched.ancestors.map(item => item.key);
                this.currentCategoryPath = `/codes/${matched.item.fullUrl}`;
            } else {
                this.activeCategory = 'all-titles';
                this.openNodes = [];
            }
        },
        findPathByFullUrl(items, fullUrl, ancestors = []) {
            for (const item of items) {
                const currentAncestors = [...ancestors, item];

                if (item.fullUrl === fullUrl) {
                    return { item, ancestors };
                }

                if (item.children && item.children.length > 0) {
                    const result = this.findPathByFullUrl(item.children, fullUrl, currentAncestors);
                    if (result) return result;
                }
            }
            return null;
        }
    },
    created() {
        // Populate categories from CategoryManager
        this.categoryList = CategoryManager.getAllLinks(this.$store, this.sortedCategories);

        // Listen for location changes
        EventBus.listen('location:changed', () => {
            this.updateActiveCategoryFromUrl();
            this.scrollActiveItemIntoView();
        });

        this.updateActiveCategoryFromUrl();

        this.$nextTick(() => {
            this.scrollActiveItemIntoView();
            this.fixAccessibilityRoles();
        });

        this.$watch(() => this.titleSearchCategory, () => {
            this.updateActiveCategoryFromUrl();
            this.scrollActiveItemIntoView();
        }, { immediate: true });
    }
};
</script>

<style scoped>
.top-codes {
    display: flex;
    align-items: center;
    position: relative;
    padding-top: 16px;
    min-height: 48px;
    padding-left: 16px;
}
.bold-black {
  font-weight: bold;
  color: black !important;
}
.tree-item-label {
  white-space: normal;
  word-break: break-word;
  max-width: 200px;
}
</style>
